export const saveDataFromUrlToStorage = () => {
    const urlParams = new URLSearchParams(window.location.search);

    const tg = urlParams.get('tg');
    if (tg) {
        sessionStorage.setItem('tg', tg);
    }
};
